define('modules/login/routes',[], function() {
	"use strict";
	var State = function($stateProvider) {
		$stateProvider.state('login', {
			url: "/login",
			templateUrl: 'modules/login/view/login.tpl.html',
			controller: 'LoginController',
			withMenu: false
		}).state('loginStudio', {
			url: "/:aliasStudio/login",
			templateUrl: 'modules/login/view/login.tpl.html',
			controller: 'LoginController',
			withMenu: false
		});
	};
	return ["$stateProvider", State];
});
